import r from "../../shared-lib/braze-shared-lib.js";
import s from "../common/event-logger.js";
import e from "../managers/braze-instance.js";
import ir from "./feature-flags-provider-factory.js";
export function logFeatureFlagImpression(t) {
  if (!e.rr()) return;
  if (!t) return !1;
  const o = ir.er().Di();
  if (!o[t]) return !1;
  const n = o[t].trackingString;
  if (!n)
    return (
      r.j.info(
        "Not logging a feature flag impression. The feature flag was not part of any matching campaign.",
      ),
      !1
    );
  const a = ir.er().Ni();
  if (a[n]) return !1;
  (a[n] = !0), ir.er().xi(a);
  const i = { fid: t, fts: n };
  return s.N(r.q.Fr, i).O;
}
